import GlobalToolbarObserver from "@zebrabi/global-toolbar-old/observers/GlobalToolbarObserver";
import GlobalToolbar from "@zebrabi/global-toolbar-old/components/GlobalToolbar";
import { AnnotationMode, store as annotationLayerStore } from "@zebrabi/annotation-layer";

/**
 * Toggles the annotation layer's annotation mode from the toolbar button. The floating menu reacts to the mode change
 * by opening or closing, and the visual redraws the chart on those menu events.
 */
class AnnotationModeObserver extends GlobalToolbarObserver {
    static readonly CLASS_NAME = "AnnotationModeObserver";

    getClassName(): string {
        return AnnotationModeObserver.CLASS_NAME;
    }

    action(action: string): void {
        if (action !== GlobalToolbar.TOOLBAR_GROUP_CLICK) {
            return;
        }

        if (annotationLayerStore.isInAnnotationMode) {
            annotationLayerStore.setAnnotationMode(AnnotationMode.View);
            annotationLayerStore.clearDraftComments();
        } else {
            annotationLayerStore.setAnnotationMode(AnnotationMode.Actions);
        }
    }

    update(): void {
        return;
    }
}

export default AnnotationModeObserver;
